import {
  Action,
  Enum,
  PlainObject,
  State,
  formatDateTime,
  formatMoney,
  formatTimeOverflowChinese,
  parseDate,
  parseTimeFromDateDiff
} from "@zyzgroup/core-common";

// 订单类型
export const XgOrderTypeEnum = new Enum({
  ROAD: { serverValue: "L", serverDescription: "路边停车订单" },
  GATE: { serverValue: "B", serverDescription: "道闸停车订单" },
  MONTH: { serverValue: "R", serverDescription: "停车场包月订单" }
});

// 订单状态
export const XgOrderStatusEnum = new Enum({
  BEGIN: { serverValue: "B", serverDescription: "开始（进行中）" },
  END: { serverValue: "E", serverDescription: "结束" },
  CANCEL: { serverValue: "F", serverDescription: "取消" },
  INIT: { serverValue: "I", serverDescription: "预缴 或 初始化" },
  OVERDUE: { serverValue: "C", serverDescription: "欠费" }
});

function reduce(state: State, payload: PlainObject): State {
  state.sn = payload.sn ? String(payload.sn) : ""; // data.sn 数据库中为 number
  state.fee = payload.fee || 0;
  state.type = payload.ctype || "";
  state.status = payload.status || "";
  state.starttime = parseDate(payload.starttime);
  state.endtime = parseDate(payload.endtime);
  // 现场照片
  state.pics = (payload.pics || []).map((p) =>
    typeof p == "string" ? p : p.url || ""
  );
  // 已付金额
  state.feeFormatted = formatMoney(state.fee, 2);
  // 订单状态
  state.statusFormatted = XgOrderStatusEnum.getName(state.status);
  // 开始时间
  state.starttimeFormatted = payload.starttime
    ? formatDateTime(state.starttime)
    : "";
  // 结束时间
  state.endtimeFormatted = payload.endtime ? formatDateTime(state.endtime) : "";
  // 停车时长
  state.duringtimeFormatted = payload.starttime
    ? formatTimeOverflowChinese(
        parseTimeFromDateDiff(state.starttime, new Date(), true),
        3
      )
    : "";
  return state;
}

export default (immutable = true) =>
  (state: State, action: Action) => {
    const nextState: State = immutable ? { ...state } : state;
    const payload = action.payload || {};
    switch (action.type) {
      case "SET_ORDER":
      case "INIT":
        // 初始化
        reduce(nextState, payload);
        break;
    }
    return nextState;
  };
